import React, { useCallback } from 'react';
import { H3 } from '@spark/ui-components/components/Typography';
import { Container, Row, Col } from 'react-bootstrap';
import { Card, CardBody, CardTitle } from '@spark/ui-components/components/Card';
import { useHistory, useParams } from 'react-router-dom';
import { ButtonWithLoading } from '@spark/ui-components/components/Button';
import { notification } from '@spark/ui-components/utils/notification';
import { reabrirVaga } from '@spark/services/recrutamento-rh';
import PageHeader from '@spark/ui-components/components/BreadCrumb';
import styled from 'styled-components';
import VagasProcessoEmAbertoCadastro from '../Cadastro/index';

const VagasProcessoEncerradosDetalhes = () => {
  const history = useHistory();
  const { id } = useParams(); 

  const handleReabrirVaga = useCallback(async () => {
    try {
      if (!id) return;
      const confirmed = window.confirm('Tem certeza que deseja reabrir esta vaga?');
      if (!confirmed) return;
      const response = await reabrirVaga(Number(id));
      notification.success('Vaga reaberta com sucesso!');
      history.goBack();
    } catch (err) {
      notification.error('Não foi possível reabrir a vaga. Tente novamente.');
    }
  }, [id, history]);

  return <Container fluid>
    <Row>
      <Col md={12}>
        <PageHeader title="" routeSegments={[{
          name: 'Início'
        }, {
          name: 'Processos encerrados'
        }, {
          name: 'Detalhes'
        }]} />

      </Col>
    </Row>
    <Row>
      <Col md={12}>
        <Card>
          <CardBody>
            <HeaderWrap>
              <CardTitle>
                <H3>Detalhes da vaga</H3>
              </CardTitle>
              <ButtonWithLoading
                variant="primary"
                onClick={handleReabrirVaga}
                style={{ backgroundColor: '#168f34', borderColor: '#168f34' }}
              >
                Reabrir vaga
              </ButtonWithLoading>
            </HeaderWrap>
            <VagasProcessoEmAbertoCadastro isReadOnly={true} id={id} hideHeader={true} />
          </CardBody>
        </Card>
      </Col>
    </Row>
  </Container>;
};

export default VagasProcessoEncerradosDetalhes;

const HeaderWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;
const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;
